import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart, Sparkles, BookOpen, Feather, Shield, Clock, Users, Star, Check, X, ChevronDown } from 'lucide-react';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { TestimonialCard } from '../components/TestimonialCard';
const CHECKOUT_URL = 'https://checkout2.rosetadigital.com/cart/46949317345458:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/rGNxsH6DDPNhjoWZUC1TZJ/ChatGPT_Image_24_dic_2025,_02_59_07.png';
const BONUS_IMAGE = 'https://cdn.magicpatterns.com/uploads/idda2cUFkLZUANZxNmSeDT/ChatGPT_Image_27_dic_2025,_12_12_36.png';
const BONUS_IMAGE_2 = 'https://cdn.magicpatterns.com/uploads/eRBWVd67Cj65gGkSPoCC6b/ChatGPT_Image_27_dic_2025,_12_09_55.png';
const BONUS_IMAGE_3 = 'https://cdn.magicpatterns.com/uploads/o4JHmwpes2V5j79a84ADCQ/ChatGPT_Image_27_dic_2025,_12_08_15.png';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 47,
    seconds: 23
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-3 justify-center" data-id="element-21">
      <div className="bg-white rounded-lg p-3 shadow-lg min-w-[70px]" data-id="element-22">
        <div className="text-3xl font-bold text-purple-900" data-id="element-23">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <div className="text-xs text-gray-500 uppercase" data-id="element-24">Horas</div>
      </div>
      <div className="bg-white rounded-lg p-3 shadow-lg min-w-[70px]" data-id="element-25">
        <div className="text-3xl font-bold text-purple-900" data-id="element-26">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <div className="text-xs text-gray-500 uppercase" data-id="element-27">Min</div>
      </div>
      <div className="bg-white rounded-lg p-3 shadow-lg min-w-[70px]" data-id="element-28">
        <div className="text-3xl font-bold text-purple-900" data-id="element-29">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <div className="text-xs text-gray-500 uppercase" data-id="element-30">Seg</div>
      </div>
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-purple-100 py-4" data-id="element-31">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center text-left" data-id="element-32">
        <span className="font-medium text-gray-900 pr-4" data-id="element-33">{question}</span>
        <ChevronDown className={`w-5 h-5 text-purple-600 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" />
      </button>
      {isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} className="mt-3 text-gray-600" data-id="element-35">
          {answer}
        </motion.div>}
    </div>;
}
export function SanarSinCulpa() {
  useEffect(() => {
    document.title = 'Sanar Sin Culpa - Guía de Sanación Interior';
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF9F6] font-sans text-gray-800" data-id="element-36">
      <SocialProofPopup data-id="element-37" />

      {/* Urgency Bar */}
      <div className="bg-gradient-to-r from-pink-500 to-purple-600 text-white py-3 px-4 text-center text-sm font-medium sticky top-0 z-50" data-id="element-38">
        <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-39">
          <Clock className="w-4 h-4" data-id="element-40" />
          <span data-id="element-41">🔥 Oferta especial termina en:</span>
          <span className="font-bold" data-id="element-42">3:47:23</span>
          <span data-id="element-43">• Solo quedan 23 copias a este precio</span>
        </div>
      </div>

      {/* Hero Section - Más directo y urgente */}
      <header className="relative pt-8 pb-12 px-4 md:px-8 bg-gradient-to-b from-purple-50 to-white" data-id="element-44">
        <div className="max-w-6xl mx-auto" data-id="element-45">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-46">
            {/* Left: Copy */}
            <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-47">
              <div className="flex items-center gap-2 mb-4" data-id="element-48">
                <div className="flex" data-id="element-49">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-50" />)}
                </div>
                <span className="text-sm text-gray-600" data-id="element-51">
                  4.9/5 • 1,547 mujeres
                </span>
              </div>

              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 leading-tight mb-4" data-id="element-52">
                Si vivís{' '}
                <span className="text-purple-600 italic" data-id="element-53">
                  cansada, culpable
                </span>{' '}
                y sintiendo que nunca es suficiente...
              </h1>

              <p className="text-xl text-gray-700 mb-6 leading-relaxed" data-id="element-54">
                Esta guía te ayudará a{' '}
                <strong data-id="element-55">soltar la culpa sin destruir vínculos</strong> y
                elegirte sin traicionar a nadie.
              </p>

              <div className="bg-purple-50 border-l-4 border-purple-400 p-4 mb-6 rounded" data-id="element-56">
                <p className="text-purple-900 font-medium" data-id="element-57">
                  "Finalmente entendí que la culpa que sentía no era mía. Pude
                  soltar sin traicionar a nadie, especialmente a mí misma."
                </p>
                <p className="text-sm text-purple-700 mt-2" data-id="element-58">
                  — María Laura, 34 años
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-59">
                <a href={CHECKOUT_URL} className="bg-purple-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-purple-700 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-60">
                  <span data-id="element-61">QUIERO SANAR HOY</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-62" />
                </a>
                <button onClick={scrollToPurchase} className="border-2 border-purple-600 text-purple-600 px-8 py-4 rounded-full font-medium hover:bg-purple-50 transition-all" data-id="element-63">
                  Ver contenido completo
                </button>
              </div>

              <div className="flex items-center gap-6 text-sm text-gray-600" data-id="element-64">
                <div className="flex items-center gap-2" data-id="element-65">
                  <Shield className="w-5 h-5 text-green-600" data-id="element-66" />
                  <span data-id="element-67">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-68">
                  <Users className="w-5 h-5 text-purple-600" data-id="element-69" />
                  <span data-id="element-70">1,547+ mujeres</span>
                </div>
              </div>
            </motion.div>

            {/* Right: Product Image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8
          }} className="relative" data-id="element-71">
              <div className="relative cursor-pointer group" onClick={() => window.open(CHECKOUT_URL, '_blank')} data-id="element-72">
                <img src={MAIN_IMAGE} alt="Sanar Sin Culpa" className="w-full max-w-md mx-auto rounded-2xl shadow-2xl group-hover:-translate-y-2 transition-transform duration-500" data-id="element-73" />
                <div className="absolute -top-4 -right-4 bg-pink-500 text-white px-6 py-3 rounded-full font-bold shadow-xl rotate-12 animate-pulse" data-id="element-74">
                  50% OFF HOY
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </header>

      {/* Social Proof Numbers */}
      <section className="py-12 px-4 bg-white border-y border-purple-100" data-id="element-75">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-76">
          <div data-id="element-77">
            <div className="text-4xl font-bold text-purple-600 mb-2" data-id="element-78">
              1,547+
            </div>
            <div className="text-gray-600" data-id="element-79">Mujeres sanando</div>
          </div>
          <div data-id="element-80">
            <div className="text-4xl font-bold text-purple-600 mb-2" data-id="element-81">4.9★</div>
            <div className="text-gray-600" data-id="element-82">Calificación promedio</div>
          </div>
          <div data-id="element-83">
            <div className="text-4xl font-bold text-purple-600 mb-2" data-id="element-84">100%</div>
            <div className="text-gray-600" data-id="element-85">Digital y práctico</div>
          </div>
          <div data-id="element-86">
            <div className="text-4xl font-bold text-purple-600 mb-2" data-id="element-87">3</div>
            <div className="text-gray-600" data-id="element-88">Bonos exclusivos</div>
          </div>
        </div>
      </section>

      {/* Problem Sections - Mantener pero más conciso */}
      <section className="py-16 px-4 md:px-8 bg-[#FAF9F6]" data-id="element-89">
        <div className="max-w-4xl mx-auto space-y-16" data-id="element-90">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center" data-id="element-91">
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-92">
              Cuando ser fuerte deja de ser suficiente
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-93">
              Desde afuera parecés estable. Responsable. Capaz. Pero por dentro
              vivís cansada, tensa y con una culpa que no sabés de dónde viene.
              Culpa por descansar. Culpa por decir que no. Culpa por pensar en
              vos.
            </p>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center" data-id="element-94">
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-95">
              El cansancio que nadie ve
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-96">
              No es cansancio físico. Es un cansancio del alma. Dormís, pero no
              descansás. Sonreís, pero estás vacía. Y lo más pesado es la
              sensación constante de estar fallando… incluso cuando nadie te lo
              pide.
            </p>
          </motion.div>
        </div>
      </section>

      {/* What's Inside - Nuevo */}
      <section className="py-16 px-4 md:px-8 bg-white" data-id="element-97">
        <div className="max-w-5xl mx-auto" data-id="element-98">
          <div className="text-center mb-12" data-id="element-99">
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-100">
              Qué vas a encontrar en Sanar Sin Culpa
            </h2>
            <p className="text-lg text-gray-600" data-id="element-101">
              Una guía completa de acompañamiento profundo y práctico
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-102">
            {[{
            title: 'Reconocer la raíz',
            desc: 'Identifica de dónde viene la culpa que cargás y por qué se repite'
          }, {
            title: 'Lealtades invisibles',
            desc: 'Entiende los mandatos familiares que repetís sin darte cuenta'
          }, {
            title: 'Honrar sin repetir',
            desc: 'Aprende a respetar tu historia sin cargar con ella'
          }, {
            title: 'Soltar sin traicionar',
            desc: 'Liberate de la culpa sin destruir vínculos importantes'
          }, {
            title: 'Elegirte sin culpa',
            desc: 'Toma decisiones desde el amor propio, no desde el miedo'
          }, {
            title: 'Vivir más liviana',
            desc: 'Integra todo lo aprendido en tu día a día con herramientas prácticas'
          }].map((item, i) => <div key={i} className="flex gap-4 p-6 bg-purple-50 rounded-xl border border-purple-100" data-id="element-103">
                <div className="flex-shrink-0 w-10 h-10 bg-purple-600 text-white rounded-full flex items-center justify-center font-bold" data-id="element-104">
                  {i + 1}
                </div>
                <div data-id="element-105">
                  <h3 className="font-semibold text-gray-900 mb-2" data-id="element-106">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-107">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-108">
            <a href={CHECKOUT_URL} className="inline-flex items-center gap-2 bg-purple-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-purple-700 transition-all shadow-xl" data-id="element-109">
              ACCEDER AHORA POR $19.990
              <ArrowRight className="w-5 h-5" data-id="element-110" />
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials - Antes de la oferta */}
      <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-purple-50 to-white" data-id="element-111">
        <div className="max-w-6xl mx-auto" data-id="element-112">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-113">
            Lo que dicen las mujeres que ya sanaron
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-114">
            <TestimonialCard name="Carolina M." age={34} location="Buenos Aires" text="Sentía que cargaba con el peso del mundo. Este libro me ayudó a entender que soltar no es abandonar, es cuidarme. Lloré, sané y me sentí abrazada en cada página." data-id="element-115" />
            <TestimonialCard name="Valeria S." age={41} location="Córdoba" text="Nunca pensé que un libro digital pudiera tocarme tan profundo. Es como si la autora me conociera de toda la vida. La culpa ya no maneja mis decisiones." data-id="element-116" />
            <TestimonialCard name="Andrea R." age={29} location="Rosario" text="El capítulo sobre las lealtades invisibles me cambió la vida. Entendí por qué repetía la historia de mi madre. Gracias por esta herramienta tan amorosa." data-id="element-117" />
            <TestimonialCard name="Patricia L." age={45} location="Mendoza" text="Lo leo cada vez que siento que la exigencia me gana. Es mi refugio. Me enseñó a decir que no sin sentirme la peor persona del mundo." data-id="element-118" />
            <TestimonialCard name="Sofía G." age={38} location="La Plata" text="Hermoso, profundo y real. No es el típico libro de autoayuda que te dice 'sé feliz'. Te acompaña a transitar el dolor para transformarlo." data-id="element-119" />
            <TestimonialCard name="Lucía M." age={36} location="Rosario" text="Después de años de terapia, este libro me dio las herramientas que me faltaban. Es como tener una guía amorosa que te entiende de verdad." data-id="element-120" />
          </div>
        </div>
      </section>

      {/* Value Comparison - Nuevo */}
      <section className="py-16 px-4 md:px-8 bg-white" data-id="element-121">
        <div className="max-w-4xl mx-auto" data-id="element-122">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-123">
            Compará el valor
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-124">
            {/* Therapy */}
            <div className="border-2 border-gray-200 rounded-2xl p-8" data-id="element-125">
              <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-126">
                Terapia tradicional
              </h3>
              <div className="text-4xl font-bold text-gray-900 mb-6" data-id="element-127">
                $8,000
                <span className="text-lg font-normal text-gray-500" data-id="element-128">
                  /sesión
                </span>
              </div>
              <ul className="space-y-3" data-id="element-129">
                <li className="flex items-start gap-2" data-id="element-130">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-131" />
                  <span className="text-gray-600" data-id="element-132">
                    Acompañamiento profesional
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-133">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-134" />
                  <span className="text-gray-600" data-id="element-135">Espacio de escucha</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-136">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-137" />
                  <span className="text-gray-400" data-id="element-138">
                    Requiere múltiples sesiones ($40,000+)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-139">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-140" />
                  <span className="text-gray-400" data-id="element-141">Horarios limitados</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-142">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-143" />
                  <span className="text-gray-400" data-id="element-144">
                    No siempre disponible cuando lo necesitás
                  </span>
                </li>
              </ul>
            </div>

            {/* This Book */}
            <div className="border-4 border-purple-400 rounded-2xl p-8 bg-purple-50 relative" data-id="element-145">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-purple-600 text-white px-6 py-2 rounded-full font-bold text-sm" data-id="element-146">
                MEJOR OPCIÓN
              </div>
              <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-147">
                Sanar Sin Culpa
              </h3>
              <div className="text-4xl font-bold text-purple-600 mb-2" data-id="element-148">
                $19.990
                <span className="text-lg font-normal text-gray-500" data-id="element-149">
                  {' '}
                  pago único
                </span>
              </div>
              <div className="text-sm text-gray-500 line-through mb-6" data-id="element-150">
                Antes $39.990
              </div>
              <ul className="space-y-3" data-id="element-151">
                <li className="flex items-start gap-2" data-id="element-152">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-153" />
                  <span className="text-gray-700 font-medium" data-id="element-154">
                    Guía completa de sanación profunda
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-155">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-156" />
                  <span className="text-gray-700 font-medium" data-id="element-157">
                    Acceso inmediato y para siempre
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-158">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-159" />
                  <span className="text-gray-700 font-medium" data-id="element-160">
                    Leelo cuando lo necesites, a tu ritmo
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-161">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-162" />
                  <span className="text-gray-700 font-medium" data-id="element-163">
                    3 bonos exclusivos incluidos
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-164">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-165" />
                  <span className="text-gray-700 font-medium" data-id="element-166">
                    Garantía de devolución 7 días
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses con urgencia */}
      <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-pink-50 to-purple-50" data-id="element-167">
        <div className="max-w-6xl mx-auto" data-id="element-168">
          <div className="text-center mb-8" data-id="element-169">
            <div className="inline-block bg-pink-500 text-white px-6 py-2 rounded-full font-bold mb-4 animate-pulse" data-id="element-170">
              🎁 REGALO EXCLUSIVO - SOLO POR HOY
            </div>
            <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-3" data-id="element-171">
              Llevate 3 bonos de regalo
            </h2>
            <p className="text-lg text-gray-600" data-id="element-172">
              Valor total: <span className="line-through" data-id="element-173">$29.970</span>{' '}
              <span className="text-pink-600 font-bold" data-id="element-174">¡GRATIS HOY!</span>
            </p>
          </div>

          <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-4 mb-8 text-center" data-id="element-175">
            <div className="flex items-center justify-center gap-2 text-yellow-900 font-bold mb-2" data-id="element-176">
              <Clock className="w-5 h-5" data-id="element-177" />
              <span data-id="element-178">Esta oferta expira en:</span>
            </div>
            <CountdownTimer data-id="element-179" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-180">
            {[{
            img: BONUS_IMAGE,
            title: 'Lealtades Invisibles',
            subtitle: 'Cómo honrar sin repetir',
            value: '$9.990'
          }, {
            img: BONUS_IMAGE_2,
            title: 'Ritual Suave para Soltar la Culpa',
            subtitle: 'Práctica guiada de liberación',
            value: '$9.990'
          }, {
            img: BONUS_IMAGE_3,
            title: 'Diario Emocional Guiado',
            subtitle: 'Volver a vos sin exigencia',
            value: '$9.990'
          }].map((bonus, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-lg border-2 border-purple-100 cursor-pointer hover:shadow-xl transition-shadow" onClick={() => window.open(CHECKOUT_URL, '_blank')} data-id="element-181">
                <div className="relative mb-4" data-id="element-182">
                  <img src={bonus.img} alt={bonus.title} className="w-full rounded-xl" data-id="element-183" />
                  <div className="absolute -top-3 -right-3 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-184">
                    GRATIS
                  </div>
                </div>
                <h3 className="font-serif text-lg text-gray-900 mb-1" data-id="element-185">
                  {bonus.title}
                </h3>
                <p className="text-sm text-gray-600 mb-2" data-id="element-186">{bonus.subtitle}</p>
                <p className="text-purple-600 font-bold" data-id="element-187">
                  Valor: {bonus.value}
                </p>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-188">
            <a href={CHECKOUT_URL} className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-10 py-5 rounded-full font-bold text-xl hover:shadow-2xl hover:-translate-y-1 transition-all shadow-xl" data-id="element-189">
              SÍ, QUIERO LOS BONOS GRATIS
              <ArrowRight className="w-6 h-6" data-id="element-190" />
            </a>
            <p className="text-sm text-gray-500 mt-4" data-id="element-191">
              Solo quedan 23 copias a este precio especial
            </p>
          </div>
        </div>
      </section>

      {/* Guarantee - Nuevo */}
      <section className="py-16 px-4 md:px-8 bg-white" data-id="element-192">
        <div className="max-w-3xl mx-auto text-center" data-id="element-193">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-194">
            <Shield className="w-10 h-10 text-green-600" data-id="element-195" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-196">
            Garantía de satisfacción 7 días
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-197">
            Si después de leer "Sanar Sin Culpa" sentís que no fue lo que
            esperabas, te devolvemos el 100% de tu dinero dentro de los primeros
            7 días. Sin preguntas, sin vueltas. Queremos que te sientas segura
            con esta decisión.
          </p>
          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6" data-id="element-198">
            <p className="text-green-900 font-medium" data-id="element-199">
              Esto significa que podés leer el libro completo, aplicar las
              herramientas, y si no te ayuda, recuperás tu inversión completa en
              los primeros 7 días. <strong data-id="element-200">No tenés nada que perder.</strong>
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 md:px-8 bg-[#FAF9F6]" data-id="element-201">
        <div className="max-w-3xl mx-auto" data-id="element-202">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-203">
            Preguntas frecuentes
          </h2>

          <div className="bg-white rounded-2xl p-8 shadow-lg" data-id="element-204">
            <FAQItem question="¿Este libro es para mí?" answer="Si sentís culpa constante, cansancio emocional, o la sensación de que nunca es suficiente, este libro es para vos. Está diseñado para mujeres que quieren sanar sin destruir vínculos ni convertirse en otra persona." data-id="element-205" />
            <FAQItem question="¿Cuánto tiempo me toma leerlo?" answer="Es una guía completa que podés leer a tu propio ritmo. Lo ideal es que te tomes el tiempo para reflexionar sobre cada sección. Muchas mujeres lo leen en una semana, volviendo a las partes que más las tocan." data-id="element-206" />
            <FAQItem question="¿En qué formato lo recibo?" answer="Es un libro digital en PDF que podés leer en tu celular, tablet o computadora. Lo recibís inmediatamente después de la compra por email." data-id="element-207" />
            <FAQItem question="¿Puedo compartirlo con alguien más?" answer="El libro es para uso personal. Si querés regalarlo a alguien, podés comprar otra copia. Cada compra ayuda a que podamos seguir creando contenido de calidad." data-id="element-208" />
            <FAQItem question="¿Realmente funciona?" answer="Más de 1,547 mujeres ya están aplicando estas herramientas. No es magia, es un proceso de autoconocimiento profundo. Requiere honestidad y tiempo, pero las transformaciones son reales y duraderas." data-id="element-209" />
            <FAQItem question="¿Qué pasa si no me gusta?" answer="Tenés 7 días de garantía desde tu compra. Si el libro no cumple tus expectativas, te devolvemos el 100% de tu dinero. Sin preguntas, sin complicaciones." data-id="element-210" />
          </div>
        </div>
      </section>

      {/* Final CTA - Más urgente */}
      <section id="purchase-section" className="py-20 px-4 md:px-8 bg-gradient-to-b from-purple-900 to-purple-800 text-white" data-id="element-211">
        <div className="max-w-4xl mx-auto text-center" data-id="element-212">
          <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-213">
            Es momento de elegirte sin culpa
          </h2>
          <p className="text-xl text-purple-100 mb-8 max-w-2xl mx-auto" data-id="element-214">
            Si estás cansada de ser la fuerte. Si sentís que vivir no debería
            doler tanto. Si querés sanar sin romperte por dentro...
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 mb-8" data-id="element-215">
            <div className="mb-6" data-id="element-216">
              <div className="text-purple-200 text-sm uppercase tracking-wide mb-2" data-id="element-217">
                Precio especial hoy
              </div>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-218">
                <span className="text-6xl font-bold" data-id="element-219">$19.990</span>
                <div className="text-left" data-id="element-220">
                  <div className="text-2xl line-through text-purple-300" data-id="element-221">
                    $39.990
                  </div>
                  <div className="text-pink-300 font-bold" data-id="element-222">50% OFF</div>
                </div>
              </div>
              <div className="text-purple-200" data-id="element-223">
                + 3 bonos gratis (valor $29.970)
              </div>
            </div>

            <a href={CHECKOUT_URL} className="inline-flex items-center gap-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-12 py-6 rounded-full font-bold text-2xl hover:shadow-2xl hover:-translate-y-1 transition-all shadow-xl mb-6 w-full md:w-auto justify-center" data-id="element-224">
              <span data-id="element-225">DESCARGAR AHORA</span>
              <ArrowRight className="w-7 h-7" data-id="element-226" />
            </a>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-purple-200" data-id="element-227">
              <span className="flex items-center gap-2" data-id="element-228">
                <Check className="w-5 h-5" data-id="element-229" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-230">
                <Check className="w-5 h-5" data-id="element-231" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-232">
                <Check className="w-5 h-5" data-id="element-233" /> Garantía 30 días
              </span>
              <span className="flex items-center gap-2" data-id="element-234">
                <Check className="w-5 h-5" data-id="element-235" /> Garantía 7 días
              </span>
            </div>
          </div>

          <div className="bg-yellow-400 text-yellow-900 rounded-xl p-4 inline-block" data-id="element-236">
            <div className="flex items-center gap-2 font-bold" data-id="element-237">
              <Clock className="w-5 h-5" data-id="element-238" />
              <span data-id="element-239">
                Solo quedan 23 copias a este precio • Oferta termina en 3:47:23
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-240">
        <p data-id="element-241">© 2025 Sanar Sin Culpa. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-242">
          Una guía hecha con amor para tu proceso de sanación.
        </p>
      </footer>
    </div>;
}
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-243">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-244" />
      <polyline points="22 4 12 14.01 9 11.01" data-id="element-245" />
    </svg>;
}